import * as React from 'react';
import { memo } from 'react';

const SvgEspressoMachine = (props) => (
  <svg width='1em' height='1em' viewBox='0 0 20 20' fill='none' {...props}>
    <path
      d='M19.583 20H.417A.417.417 0 0 1 0 19.583V16.25c0-.23.187-.417.417-.417h9.674l2.292-9.166H.417A.417.417 0 0 1 0 6.25V.417C0 .187.187 0 .417 0h19.167c.229 0 .416.187.416.417v19.166c0 .23-.187.417-.416.417Zm-18.75-.833h18.334V.834H.832v5h12.084a.414.414 0 0 1 .404.518l-2.5 10a.416.416 0 0 1-.404.315H.834v2.5Z'
      fill='#000'
    />
    <path
      d='M5 6.667h.834v1.667H5V6.667ZM5.903 16.667H4.93a3.267 3.267 0 0 1-3.263-3.264v-2.986c0-.23.186-.417.416-.417H8.75c.23 0 .417.187.417.417v2.986c0 1.8-1.464 3.264-3.263 3.264ZM2.5 10.833v2.57c0 1.34 1.09 2.43 2.43 2.43h.973c1.34 0 2.43-1.09 2.43-2.43v-2.57H2.5Z'
      fill='#000'
    />
    <path
      d='M2.5 14.167H1.233c-.68 0-1.233-.553-1.233-1.233v-.867c0-.68.554-1.233 1.233-1.233h.434v.834h-.434a.4.4 0 0 0-.4.399v.867c0 .22.18.4.4.4H2.5v.833ZM17.917 18.333h-3.333a.417.417 0 0 1-.417-.417V16.25c0-.23.188-.417.417-.417h3.333c.23 0 .417.187.417.417v1.666c0 .23-.188.417-.417.417ZM15 17.5h2.5v-.833H15v.833Z'
      fill='#000'
    />
  </svg>
);

const Memo = memo(SvgEspressoMachine);
export default Memo;
